// assets/cart-submit-handler.js
document.addEventListener(
  "submit",
  function (event) {
    const form = event.target.closest("#cart, #CartDrawer-Form");
    // 验证确实是购物车表单
    if (!form || !form.action.includes("/cart") || !form.method === "post")
      return;
    handleCartSubmit(event);
  },
  true
); // 使用捕获阶段

const CONFIG = {
  PRODUCT_ID: "8379706802354", // 产品ID
  GIFT_ID: "8472946147506", // 赠品ID
  DISCOUNT_CODE: "lovemom10", // 优惠码
};
/**
 * 购物车表单提交处理器（赠品活动逻辑）
 * @param {Event} event - 表单提交事件
 */
async function handleCartSubmit(event) {
  // 1. 阻止默认提交但保留参数
  event.preventDefault();

  const form = event.target;

  try {
    // 1. 获取购物车数据
    const cart = await fetch("/cart.js").then((res) => res.json());

    // 2. 检查活动商品
    const isPromotionUser =
      cart.items.some(
        (item) => item.product_id.toString() === CONFIG.PRODUCT_ID
      ) &&
      cart.items.some((item) => item.product_id.toString() === CONFIG.GIFT_ID);

    if (!isPromotionUser) {
      window.location.href = "/checkout";
      return;
    }

    // 3. 处理赠品逻辑
    const giftResponse = await fetch("/api/2024-07/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "ea525b3f4dd9eafcc1dbaac99ae8f4f1",
      },
      body: JSON.stringify({
        query: `{  product(id: "gid:\/\/shopify\/Product\/8472946147506") {
          totalInventory
        }
      }`,
      }),
    });
    if (!giftResponse.ok) throw new Error("Get Inventory Error");
    const giftData = await giftResponse.json();
    const giftInventory = giftData.data.product.totalInventory;

    if (giftInventory > 1) {
      // 有库存，检查国家
      const { value: country } = await Swal.fire({
        html: `<p style="font-size: 22px; color: #121212;font-weight: bolder;">Select Shipping Country/Region</p>`,
        // title: "Select Shipping Country/Region",
        input: "select",
        inputOptions: { US: "US - Campaign Region", OTHER: "Other Countries" },
        padding: "30px",
        showCancelButton: false,
        allowOutsideClick: false,
        width: window.innerWidth >= 992 ? "33%" : "90%",
        minWidth: "300px", // 移动端最小宽度
        customClass: {
          // 新增：添加自定义类
          confirmButton: "custom-confirm-btn",
          input: "custom-select",
        },
        didOpen: () => {
          document.querySelector(".custom-confirm-btn").style.fontSize = "14px";
          document.querySelector(".custom-confirm-btn").style.padding =
            "7px 22px";
          document.querySelector(".custom-confirm-btn").style.margin = "10px";

          document.querySelector(".custom-select").style.fontSize = "14px";
          document.querySelector(".custom-select").style.padding = "8px";
          document.querySelector(".custom-select").style.margin = "10px";
          document.querySelector(".custom-confirm-btn").style.backgroundColor =
            "#2AD2C5";
        },
      });

      if (country === "US") {
        window.location.href = "/checkout";
        return;
      }
      if (country === "OTHER") {
        await handleNoGift(form, cart, false);
      }
    } else {
      await handleNoGift(form, cart, true);
    }
  } catch (error) {
    console.error("Checkout error:", error);
    Swal.fire("Error", "Processing failed, please retry", "error");
  }
}

// 辅助函数
async function handleNoGift(form, cart, isSoldOut) {
  const giftItem = cart.items.find(
    (item) => item.product_id.toString() === CONFIG.GIFT_ID
  );
  // 从购物车移除赠品
  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: giftItem.key, quantity: 0 }),
  });

  // 弹窗提示
  const { isConfirmed } = await Swal.fire({
    html: `
    <div>
    <p style="font-size: 26px; color: #121212;font-weight: bolder;margin: 0">Extra <span style="color: #2AD2C5;">10%</span> off</p>
      <p style="font-size: 14px; color: #121212;text-align: left;">${
        isSoldOut
          ? "We're sorry, the limited gifts have already been claimed,"
          : "Oops! Looks like giftbox aren't available in your region,"
      } but we've got you covered with an exclusive 10% discount code:</p>
      <div style="
        font-size: 20px;
        font-weight: bold;
        color: #FFFFFF;
        background: #000000;
        padding: 10px;
        border-radius: 25px;
        margin: 20px 5px;
        text-lign: center;
      ">
        ${CONFIG.DISCOUNT_CODE}
      </div>
    </div>
  `,
    allowOutsideClick: false,
    showCancelButton: true,
    cancelButtonText: "Cancel",
    confirmButtonText: `Copy`,
    buttonsStyling: false, // 新增：禁用默认样式
    customClass: {
      // 新增：添加自定义类
      confirmButton: "custom-confirm-btn",
      cancelButton: "custom-cancel-btn",
      actions: "custom-actions",
    },
    focusConfirm: false,
    width: window.innerWidth >= 992 ? "33%" : "90%",
    minWidth: "300px", // 移动端最小宽度
    padding: "20px 30px 30px 30px", // 弹窗内边距
    didOpen: () => {
      // 新增：直接在JS中设置样式
      // 设置按钮文字大小
      document.querySelector(".custom-confirm-btn").style.fontSize = "14px";
      document.querySelector(".custom-cancel-btn").style.fontSize = "14px";
      // 设置按钮间距
      document.querySelector(".custom-actions").style.gap = "80px";
      // 设置按钮内边距
      document.querySelector(".custom-confirm-btn").style.padding = "7px 20px";
      document.querySelector(".custom-cancel-btn").style.padding = "7px 13px";
      // 设置按钮背景色
      document.querySelector(".custom-confirm-btn").style.backgroundColor =
        "#2AD2C5";
      document.querySelector(".custom-cancel-btn").style.backgroundColor =
        "#80808070";
      // 设置按钮文字颜色
      document.querySelector(".custom-confirm-btn").style.color = "#fff";
      document.querySelector(".custom-cancel-btn").style.color = "#fff";
      // // 设置按钮圆角
      document.querySelector(".custom-confirm-btn").style.borderRadius = "4px";
      document.querySelector(".custom-cancel-btn").style.borderRadius = "4px";
      // // 新增：完全去掉边框
      document.querySelector(".custom-confirm-btn").style.border = "none";
      document.querySelector(".custom-cancel-btn").style.border = "none";

      // 确认按钮点击处理
      document
        .querySelector(".swal2-confirm")
        .addEventListener("click", async () => {
          try {
            await navigator.clipboard.writeText(CONFIG.DISCOUNT_CODE);
            Swal.showValidationMessage("✅ Copied!");
          } catch (err) {
            Swal.showValidationMessage("📋 Press Ctrl+C to copy");
          }
          // 无论复制成功与否，500ms 后跳转（确保弹窗关闭）
          setTimeout(() => (window.location.href = "/checkout"), 500);
        });
      // 取消按钮点击处理
      document.querySelector(".swal2-cancel").addEventListener("click", () => {
        window.location.reload();
      });
    },
  });
}
